import { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton, Modal } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';
import { Col, Row } from '../flexDirection';
import * as S from './styled';
import { i18n } from '../../services/i18n';
import { Add as PlusIcon, Remove as MinusIcon } from '@mui/icons-material';
import { DraggableImage } from '../DraggableImage.tsx/DraggableImage';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'https://unpkg.com/pdfjs-dist@5.4.296/build/pdf.worker.min.mjs',
  import.meta.url
).toString();

export const ViewDocumentModal: FC<any> = (props) => {
  const { t } = useTranslation();
  const { onClose, item } = props;
  const handleClose = () => onClose();
  const [scale, setScale] = useState(1);
  const [numPages, setNumPages] = useState<number | null>(null);

  const handleDownload = () => {
    if (!item?.url) return;
    location.href = item?.url;
  };

  useEffect(() => {
    setScale(1);
  }, [item]);

  const handleZoomIn = () => setScale((s) => s + 0.1);
  const handleZoomOut = () => setScale((s) => Math.max(s - 0.1, 0.1));

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <S.ModalContentWrapper
        $width={item?.fileType?.toLowerCase() === 'pdf' ? '700px' : 'auto'}
        $maxWidth="80%"
        $maxHeight="80%"
        $height="fit-content"
        style={{ flexFlow: 'column' }}
      >
        {item?.fileType?.toLowerCase() === 'pdf' ? (
          <Col style={{ maxHeight: '700px', overflowY: 'auto' }}>
            <Document
              file={item?.url}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              options={{
                httpHeaders: { lang: i18n.resolvedLanguage },
                withCredentials: true,
              }}
            >
              {Array.from(new Array(numPages), (_, i) => (
                <Page
                  key={`page_${i + 1}`}
                  pageNumber={i + 1}
                  scale={scale}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              ))}
            </Document>
          </Col>
        ) : (
          item?.url && <DraggableImage src={item?.url} scale={scale} width="710px" />
        )}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
            gap: '16px',
          }}
        >
          <Row>
            <IconButton aria-label="zoom-out" color="primary" onClick={handleZoomOut}>
              <MinusIcon />
            </IconButton>
            <IconButton aria-label="zoom-in" color="primary" onClick={handleZoomIn}>
              <PlusIcon />
            </IconButton>
          </Row>
          <Button variant="contained" onClick={handleDownload}>
            {t('view-document.download')}
          </Button>
          <Button variant="outlined" onClick={handleClose}>
            {t('view-document.cancel')}
          </Button>
        </div>
      </S.ModalContentWrapper>
    </Modal>
  );
};
